type Employee={id:string;chat_enabled?:boolean;external_discoverable?:boolean;external_discovery_revision?:string};
type PermissionState={employee:Employee;pending:boolean;ambiguous:boolean;revision:string;enabled:boolean;note:string};
/** Each employee keeps an unresolved permission until explicit server readback. */
export function initEmployeeDiscoverability(){
 const box=document.getElementById('employee-external-discovery');
 const input=document.getElementById('employee-external-discovery-enabled') as HTMLInputElement|null;
 const save=document.getElementById('employee-external-discovery-save') as HTMLButtonElement|null;
 const check=document.getElementById('employee-external-discovery-check') as HTMLButtonElement|null;
 const note=document.getElementById('employee-external-discovery-note');
 const unresolved=new Map<string,PermissionState>();
 let current:PermissionState|null=null;
 function render(){
  box?.classList.toggle('hidden',!current);
  if(input)input.disabled=!current||current.pending||current.ambiguous||(current.employee.chat_enabled===false&&!current.enabled);
  if(save)save.disabled=!current||current.pending||current.ambiguous||(current.employee.chat_enabled===false&&input?.checked===true)||input?.checked===current.enabled;
  check?.classList.toggle('hidden',!current?.ambiguous);if(check)check.disabled=current?.pending===true;
  if(note)note.textContent=current?.note??'';
 }
 async function change(readback:boolean){
  if(!current||current.pending||(!readback&&current.ambiguous))return;
  const state=current,id=state.employee.id,wanted=input?.checked===true;
  state.pending=true;unresolved.set(id,state);state.note=readback?'Проверяем состояние…':'Сохраняем разрешение…';render();
  try{
   const response=await fetch(`/api/employees/${id}/external-discovery`,{method:readback?'GET':'PUT',credentials:'same-origin',headers:readback?{}:{'content-type':'application/json'},...(readback?{}:{body:JSON.stringify({enabled:wanted,revision:state.revision,attemptId:crypto.randomUUID()})})});
   const body=await response.json() as {enabled?:unknown;revision?:unknown};
   if(!response.ok||typeof body.enabled!=='boolean'||typeof body.revision!=='string'||!/^(0|[1-9][0-9]{0,18})$/.test(body.revision))throw new Error('unconfirmed_permission');
   state.enabled=body.enabled;state.revision=body.revision;state.employee.external_discoverable=body.enabled;state.employee.external_discovery_revision=body.revision;state.ambiguous=false;
   state.note=state.enabled?'Можно найти по точной почте.':'Другие компании не могут найти этого сотрудника.';
   if(current===state&&input)input.checked=state.enabled;
   unresolved.delete(id);
  }catch{
   state.ambiguous=true;state.note='Не удалось подтвердить разрешение. Проверьте состояние перед повторным изменением.';
  }finally{state.pending=false;if(current===state)render();}
 }
 input?.addEventListener('change',render);
 save?.addEventListener('click',()=>void change(false));check?.addEventListener('click',()=>void change(true));
 return {
  open(employee:Employee){
   current=unresolved.get(employee.id)??{employee,enabled:employee.external_discoverable===true,revision:employee.external_discovery_revision??'0',pending:false,ambiguous:false,note:employee.chat_enabled===false?'Для поиска нужен доступ к чату.':employee.external_discoverable===true?'Можно найти по точной почте.':'Поиск другими компаниями выключен.'};
   current.employee=employee;if(input)input.checked=current.enabled;render();
  },
  close(){current=null;render();},
 };
}
